class ConfiguratorNightstands {
    cylindo_mapping = {
        'holmeclassic-37x37-brass': 'BRASS',
        'holmeclassic-37x37-chrome': 'CHROME',
        'holmeclassic-37x37-black': 'CLASSIC_BLACK',
        'holmeclassic-37x37-brass': 'BRASS',
        'holmeclassic-37x37-chrome': 'CHROME',
        'holmeclassic-37x37-black': 'CLASSIC_BLACK',
        'holmeclassic-37x37-walnut': 'HOLMECLASSIC IN WALNUT',
        'holmedoor-37x37-walnut': 'HOLMEDOOR IN WALNUT',
        'holmedoor-37x37-walnutleft': 'HOLMEDOOR IN WALNUT',
        'holmedoor-37x37-walnutright': 'HOLMEDOOR IN WALNUT',
        'holmedoorhigh-37x37-walnut': 'HOLMEDOORHIGH IN WALNUT',
        'holmedoorhigh-37x37-walnutleft': 'HOLMEDOORHIGH IN WALNUT',
        'holmedoorhigh-37x37-walnutright': 'HOLMEDOORHIGH IN WALNUT',
        'doorhigh-37x37-walnut': 'HOLMEDOORHIGH IN WALNUT',
        'doorhigh-37x37-walnutleft': 'HOLMEDOORHIGH IN WALNUT',
        'doorhigh-37x37-walnutright': 'HOLMEDOORHIGH IN WALNUT',
        'holmefabric': 'UPHOLSTERED',
        'holmefabricuk': 'UPHOLSTERED',
    }

    constructor() {
        this.id = 'nightstands';
        this.cache = { 'data': [], 'products': [] };

        this.selectors = [
            'nightstands'
        ];

        configurator.addSelectorItem(this.id);
    }

    async refresh(selector) {
        // Check if nightstands should be disabled for certain headboards
        const selectedHeadboard = configurator.selection.headboards;
        const shouldDisableNightstands = selectedHeadboard && (
            selectedHeadboard.includes('vallero') ||
            selectedHeadboard.includes('pinno282x149st') ||
            selectedHeadboard.includes('st') // Any headboard with side table
        );

        if (shouldDisableNightstands || configurator.selection.fabric == null) {
            configurator.resetSelectorData(this.id);
            return;
        }
        if (!(configurator.selection.size in this.cache) || !(configurator.selection.fabric in this.cache[configurator.selection.size])) {
            await this.loadItems(configurator.selection.size, configurator.selection.fabric);
        }

        this.populateItems();
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector);
    }

    setupListeners() {
    }

    async loadItems(size, fabric) {
        // Check if already loaded
        if (size in this.cache && fabric in this.cache[size]) {
            return;
        }
        // Init data object
        if (!(size in this.cache)) {
            this.cache[size] = { 'title': size, 'fabrics': {}, 'products': {} };
        }
        this.cache[size]['fabrics'][fabric] = { 'title': fabric, 'products': {} };
        const size_arr = size.split('x');
        const is_double = size_arr[0] > 119 ? true : false;
        // Load Headstands without fabric
        const products_plain = await configurator.loadProductData('configurator-' + this.id, [], [], true);

        // Load Headstands with fabric
        const products_with_fabric = await configurator.loadProductData('configurator-bedside-tables', [
            { key: 'fabric', value: fabric },
        ], [], true);

        const nightstands = products_plain.filter(p =>
            p.productid.includes('table') || p.productid.includes('holmeclassic') ||
            p.productid.includes('holmedoor') || p.productid.includes('holmedoorhigh')
        );
        for (const nightstand of nightstands) {
            for (const variant of nightstand.variants) {
                // Skip variants with price 0 when e-commerce is enabled
                if (variant.price == 0 && configurator.enable_ecommerce == true) { continue; }

                // Skip if SKU is globally excluded
                if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(variant.sku)) {
                    console.log(`Nightstand SKU ${variant.sku} for product ${nightstand.productid} (plain) excluded globally.`);
                    continue;
                }

                let lbl = nightstand.title + ' ' + variant.option2.replace(/ left/gi, '').replace(/ right/gi, '');
                let variant_handle = nightstand.productid + '-' + variant.title.toLowerCase().replace(/\s/g, '').replace(/\//g, '-').replace(/left/g, '').replace(/right/g, '');
                const variant_id = variant.id.replace('gid://shopify/ProductVariant/', '');
                // Build Cylindo thumbnail URL
                if (nightstand.cylindo_model != null) {
                    variant.featured_image = { 'src': this.getCylindoThumbnail(nightstand, variant) };
                }
                var isLeftRight = variant.option2.toLowerCase().includes('left') || variant.option2.toLowerCase().includes('right');
                if (this.cache[size]['products'][variant_handle] && is_double && isLeftRight) {
                    this.cache[size]['products'][variant_handle].skus.push(variant.sku);
                    this.cache[size]['products'][variant_handle].ids.push(variant_id);
                    //purge for doubles
                    this.cache[size]['products'][variant_handle].ids = [...new Set(this.cache[size]['products'][variant_handle].ids)];
                    this.cache[size]['products'][variant_handle].skus = [...new Set(this.cache[size]['products'][variant_handle].skus)];
                    continue;
                }
                this.cache[size]['products'][variant_handle] = {
                    'id': variant_handle,
                    'skus': is_double && !isLeftRight ? [variant.sku, variant.sku] : [variant.sku],
                    'ids': is_double && !isLeftRight ? [variant_id, variant_id] : [variant_id],
                    'price': variant.price * (is_double ? 2 : 1),
                    'label': (is_double ? '2 x ' : '') + lbl,
                    'thumbnail': variant.featured_image ? variant.featured_image.src : variant.image,
                    'available': variant.availableForSale,
                };
            }
        }

        for (const product of products_with_fabric) {
            // Skip products with price 0 when e-commerce is enabled
            if (product.variants[0].price == 0 && configurator.enable_ecommerce == true) { continue; }

            // Skip if the primary variant's SKU is globally excluded
            if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(product.variants[0].sku)) {
                console.log(`Nightstand SKU ${product.variants[0].sku} for product ${product.productid} (with fabric) excluded globally.`);
                continue;
            }

            // Find Reference Product parent
            configurator.applyReferenceProduct(product);

            // Build Cylindo thumbnail URL
            if (product.cylindo_model != null) {
                product.image = this.getCylindoThumbnail(product);
            }
            const variant_id = product.variants[0].id.replace('gid://shopify/ProductVariant/', '');
            // Add to data array
            this.cache[size]['fabrics'][fabric]['products'][product.productid] =
            {
                'id': product.productid,
                'handle': product.productid,
                'label': (is_double ? '2 x ' : '') + product.title,
                'ids': is_double ? [variant_id, variant_id] : [variant_id],
                'skus': is_double ? [product.variants[0].sku, product.variants[0].sku] : [product.variants[0].sku],
                'price': product.variants[0].price * (is_double ? 2 : 1),
                'thumbnail': product.image,
                'available': product.variants[0].availableForSale,
            };
            configurator.productToItem(product);
        }
    }

    populateItems() {
        let sel_size = configurator.selection.size;
        console.log(this.cache);
        this.items = {
            ...this.cache[sel_size]['fabrics'][configurator.selection.fabric]['products'],
            ...this.cache[sel_size]['products']
        };
        configurator.renderSelector(this.id, Object.values(this.items), {
            'thumbnails': true,
            'columns': 3,
        });
    }

    isSoldOut() {
        const item = configurator.selection.nightstands ? this.items[configurator.selection.nightstands] : null;

        if (item && item.available) return false;
        return true;
    }

    getPriceData(priceData) {
        const item = configurator.selection.nightstands ? this.items[configurator.selection.nightstands] : null;

        if (item != null) {
            priceData.total += item.price ?? 0;
            priceData.skus.push(...item.skus);
            priceData.ids.push(...item.ids);
        }
    }

    getCylindoSpecs(specs) {
        // ============== Translate Nightstand config ==============    
        if (configurator.selection.nightstands == null) {
            specs.features['BEDSIDE TABLE'] = 'OFF';
            return;
        }
        const n = configurator.selection.nightstands.replace("-top", "");

        if (n in this.cylindo_mapping) {
            specs.features['BEDSIDE TABLE'] = this.cylindo_mapping[n];
        }
    }

    getCylindoThumbnail(product, variant) {
        let base_url = bed_configuration.cylindo_base_url + product.cylindo_model + '/frames/3/' + product.cylindo_model + '.jpg?'
            + 'size=512&background=f7f7f7&encoding=jpg&feature=BEDSIDE%20TABLE:';

        if (product.handle.includes('fabric')) {
            const cylindo_fabric = configurator.m3_fabrics[configurator.selection.fabric][0];
            base_url += `UPHOLSTERED&feature=UPHOLSTERY:${cylindo_fabric}`;
        } else if (variant?.option2) {
            const isHigh = product.handle?.includes('doorhigh') || product.productid?.includes('doorhigh');
            var mapping = {
                'WALNUT LEFT': isHigh ? 'HOLMEDOORHIGH IN WALNUT' : 'HOLMEDOOR IN WALNUT',
                'WALNUT RIGHT': isHigh ? 'HOLMEDOORHIGH IN WALNUT' : 'HOLMEDOOR IN WALNUT',
                'WALNUT': isHigh ? 'HOLMEDOORHIGH IN WALNUT' : 'HOLMEDOOR IN WALNUT',
                'WALNUT HIGH LEFT': 'HOLMEDOORHIGH IN WALNUT',
                'WALNUT HIGH RIGHT': 'HOLMEDOORHIGH IN WALNUT'
            };
            const cylindo_color = configurator.m3_colors[variant.option2] || variant.option2.toUpperCase();
            base_url += `${mapping[cylindo_color] || cylindo_color}`;
        }

        return base_url;
    }
}
